import React from "react";
import { useOctopusTheme } from "~/components/Theme/index";

export function CloudConnectionWarningIcon() {
    const theme = useOctopusTheme();
    return <em className={`fa-solid fa-exclamation-circle`} style={{ color: theme.alertText }} />;
}
